import { render, staticRenderFns } from "./boardroomListItem.vue?vue&type=template&id=8be01a70&scoped=true&"
import script from "./boardroomListItem.vue?vue&type=script&lang=js&"
export * from "./boardroomListItem.vue?vue&type=script&lang=js&"
import style0 from "./boardroomListItem.vue?vue&type=style&index=0&id=8be01a70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be01a70",
  null
  
)

export default component.exports